__turbopack_context__.v({
  "list": "TcCgqW_list",
});
